import { render, staticRenderFns } from "./CreatePlacement.vue?vue&type=template&id=04ce07cb&scoped=true"
import script from "./CreatePlacement.vue?vue&type=script&lang=js"
export * from "./CreatePlacement.vue?vue&type=script&lang=js"
import style0 from "./CreatePlacement.vue?vue&type=style&index=0&id=04ce07cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ce07cb",
  null
  
)

export default component.exports